import { render, staticRenderFns } from "./areaSet.vue?vue&type=template&id=23aec4f2&scoped=true&"
import script from "./areaSet.vue?vue&type=script&lang=js&"
export * from "./areaSet.vue?vue&type=script&lang=js&"
import style0 from "./areaSet.vue?vue&type=style&index=0&lang=css&"
import style1 from "./areaSet.vue?vue&type=style&index=1&id=23aec4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aec4f2",
  null
  
)

export default component.exports